{{#if !miniMaps}}
<div class='dots-and-line-key'>


<div class='row-for-outline-color'>

	<p class='outline-key-text'>St Louis city limits</p>
	<svg>
		<line x1='2' y1='10' x2='18' y2='10'></line>
	</svg>
</div>

<div class='row-for-outline-color'>

	<p class='outline-key-text'>2015 gun homicide incident</p>
	<div class='murder dot'>
		<svg>
			<circle cx="9" cy="9" r="2"></circle>
		</svg>
	</div>
</div>
</div>
{{/if}}


{{#if sceneIndex > 2}}
<div class={{!miniMaps ? "background-box" : "background-box-mini-maps"}}>


<p class={{!miniMaps ? 'key-sub-head' : 'key-sub-head-mini-maps'}}>Percent {{statLookup[sceneIndex]}}</p>
<div class='key-box'>

{{#each key_arrs[sceneIndex] as gradation}}
<div class='key-grade' style='background-color: {{gradation}}; opacity: .9;'>
<p class='key-text'>{{key_labels[sceneIndex][gradation] ? key_labels[sceneIndex][gradation] : "" }}</p>
</div>
{{/each}}
</div>
</div>
{{/if}}
<style>

.dots-and-line-key {
	position: absolute;
	left: 18px;
	bottom: 104px;


}


svg {
	width: 20px;
}

line {
	stroke-width: 2;
	stroke: #767676;
}

circle {
	fillColor: #333;
	fillOpacity: 0.2;
}

.outline-key-text {
	/*margin-top: 10px;*/
	height: 20px;
	font-weight: 900;
}

.row-for-outline-color {
	display: flex;
	width: 200px;
	justify-content: flex-start;
	align-content: center;
	height: 20px;
}
.outline-color-key {
	border-top: #767676 1.5px solid;
	width: 20px;
	height: 2px;
}

.background-box {
	background-color: transparent;
	padding: 10px;
	width: 230px;
	height: 66px;
	position: absolute;
	bottom: 30px;
	left: -12px;

}

.background-box-mini-maps {
	background-color: rgba(255, 255, 255, .8);
	padding: 10px;
	width: 250px;
	height: 66px;
	position: absolute;
}

.key-sub-head {
	margin-left: 20px;
	font-weight: 900;

}

.key-sub-head-mini-maps {
	margin-left: 20px;
	font-weight: 900;
}

.key-text {
	margin-top: 20px;
	margin-left: 18px;
	color: #767676;
	font-size: 12px;
}

.key-text:last-of-type {
	margin-left: 15px;
}

.key-box {
	width: 200px;
	height: 20px;
	display: flex;
	flex-direction: row-reverse;
}

.key-grade{
	width: 20px;
	height: 100%;
}


@media(min-width:780px) {
.dots-and-line-key {
top: 0;
left: 62px;
}

.background-box {
	background-color: rgba(255, 255, 255, .8);
	left: 30px;
}
}

</style>

<script>
const key_label_black = {
	'#c05303': '100',
	'#eba883': '50',
	'transparent': '0'
}

const key_label_poverty = {
	'#507892': '80',
	'#a7b9c8': '40',
	'transparent': '0'
}

const key_label_education = {
	'#951c55': '80',
	'#cf91a6': '40',
	'transparent': '0'
}

const key_arr_black = [
	'#c05303',
	'#ca6425',
	'#d4753d',
	'#dc8655',
	'#e4976c',
	'#eba883',
	'#f1b99c',
	'#f6cab4',
	'#fadccc',
	'#fdeee6',
	'transparent'
];

const key_arr_poverty = [
	'rgba(255,255,255,0)',
	'rgba(255,255,255,0)',
	'#507892',
	'#66879f',
	'#7b98ac',
	'#91a8ba',
	'#a7b9c8',
	'#bdcad5',
	'#d2dbe3',
	'#e9eef1',
	'transparent'
]

const key_arr_education = [
	'rgba(255,255,255,0)',
	'rgba(255,255,255,0)',
	'#951c55',
	'#a43f68',
	'#b45c7c',
	'#c27791',
	'#cf91a6',
	'#dcacbb',
	'#e8c7d1',
	'#f4e3e8',
	'transparent'
]

const key_arrs = ["", "", "", key_arr_poverty, key_arr_education, key_arr_black ]
const key_labels = ["", "", "", key_label_poverty, key_label_education, key_label_black ]

const statLookup = ["", "", "", "below 100% poverty line", "without high school degree", "black"];
export default {
	data () {
		return {
			key_arrs,
			key_labels,
			statLookup
		};
	}
};
</script>
